<template>
    <h2 id="propertyDetailTitle" class="f4 wrap text-bold singleline">{{ molang('dpp.propertyDetails.propertyDetailsHeader') }}</h2>
    <table class="dpp-records">
        <tbody>
            <tr>
                <td>
                    <i v-bind:class="['f3 text-main', dpp.propertyTypeIcon]"></i>
                    <span>{{ molang('dpp.propertyDetails.propertyType') }}</span>
                    <b>{{ dpp.propertyTypeDisplay || '—' }}</b>
                </td>
            </tr>
            <tr v-if="dpp.createTimeDisplay && !dpp.hideDaysOnMarket">
                <td>
                    <i class="icon-logo-m-new"></i>
                    <span>{{ molang('dpp.propertyDetails.timeOnMovoto') }}</span>
                    <b data-allow-mismatch="text">{{ dpp.createTimeDisplay }} </b>
                </td>
            </tr>
            <tr v-if="dpp.lotSize">
                <td>
                    <i class="icon-size"></i>
                    <span>{{ molang('dpp.propertyDetails.lotSize') }}</span>
                    <b>{{ $filters.formatFriendlyLotSize(dpp.lotSize, dpp.lotSizeUnit) }} </b>
                </td>
            </tr>
            <tr v-if="dpp.yearBuilt">
                <td>
                    <i class="icon-year-built"></i>
                    <span>{{ molang('dpp.propertyDetails.yearBuilt') }}</span>
                    <b>{{ dpp.yearBuilt || '—' }} </b>
                </td>
            </tr>
            <tr v-if="dpp.garage">
                <td>
                    <i class="icon-investment"></i>
                    <span>{{ molang('dpp.propertyDetails.garageSpaces') }}</span>
                    <b>{{ dpp.garage }} </b>
                </td>
            </tr>
            <tr v-if="dpp.fCooling">
                <td>
                    <i class="icon-snow"></i>
                    <span>{{ molang('dpp.propertyDetails.cooling') }}</span>
                    <b>{{ dpp.fCooling }} </b>
                </td>
            </tr>
            <tr v-if="dpp.fHeating">
                <td>
                    <i class="icon-fireplace"></i>
                    <span>{{ molang('dpp.propertyDetails.heating') }}</span>
                    <b>{{ dpp.fHeating }} </b>
                </td>
            </tr>
            <tr v-if="dpp.fLevels">
                <td>
                    <i class="icon-double-layer"></i>
                    <span>{{ molang('dpp.propertyDetails.levels') }}</span>
                    <b>{{ dpp.fLevels }} </b>
                </td>
            </tr>
            <tr v-if="dpp.geo.neighborhood">
                <td>
                    <i class="icon-user-group"></i>
                    <span>{{ molang('dpp.propertyDetails.neighborhood') }}</span>
                    <b>{{ dpp.geo.neighborhood }} </b>
                </td>
            </tr>
            <tr v-if="dpp.geo.county">
                <td>
                    <i class="icon-location-arrow"></i>
                    <span>{{ molang('dpp.propertyDetails.county') }}</span>
                    <b>{{ countyName }} </b>
                </td>
            </tr>
            <tr v-if="dpp.localHighlight && dpp.localHighlight.nearestTransit && [310, 484, 300].includes(dpp.mlsDbNumber)">
                <td>
                    <i class="icon-transit"></i>
                    <span>{{ molang('dpp.propertyDetails.transitStation') }}</span>
                    <b class="link" @click="popMapView" role="button">{{ dpp.localHighlight.nearestTransit }} </b>
                </td>
            </tr>
            <tr v-if="dpp.localHighlight && dpp.localHighlight.shorelineDist && dpp.localHighlight.shorelineDist < 2">
                <td>
                    <i class="icon-water-view"></i>
                    <span>{{ molang('dpp.propertyDetails.distanceToCoast') }}</span>
                    <b class="link" @click="popMapView" role="button">{{ dpp.localHighlight.shorelineDist }} Mi </b>
                </td>
            </tr>
            <tr v-if="dpp.localHighlight && dpp.localHighlight.waterbodyDist && dpp.localHighlight.waterbodyDist < 0.1">
                <td>
                    <i class="icon-water-view"></i>
                    <span>{{ molang('dpp.propertyDetails.distanceToLake') }}</span>
                    <b class="link" @click="popMapView" role="button">{{ dpp.localHighlight.waterbodyDist }} Mi </b>
                </td>
            </tr>
            <tr v-if="dpp.nearbySchoolAvgRating">
                <td>
                    <i class="icon-cap"></i>
                    <span v-tip :tip="molang('dpp.propertyDetails.ratingTip')">{{ molang('dpp.propertyDetails.greatSchool') }} <i class="f7 text-gray icon-question-circle"></i> </span>
                    <b @click="openSchool" v-scroll="'locationPanel'" class="link" role="button">{{ `${dpp.nearbySchoolAvgRating.min}/10 - ${dpp.nearbySchoolAvgRating.max}/10` }} </b>
                </td>
            </tr>
            <tr v-if="propertyOrientation">
                <td>
                    <i class="icon-view"></i>
                    <span>{{ molang('dpp.propertyDetails.propertyOrientation') }}</span>
                    <b>{{ propertyOrientation }} Facing </b>
                </td>
            </tr>
            <tr v-if="dpp.isActive && dpp.pricePerArea">
                <td>
                    <i class="icon-investment"></i>
                    <span>Rent ($/{{ dpp.isLand ? 'Acre' : 'Sqft' }})</span>
                    <b>{{ $filters.formatPricePerArea(dpp.pricePerArea, dpp.isLand, glb.rentals) }}/{{ dpp.areaUnit }} </b>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script src="./property-baserecord-rental.js"></script>

<style lang="scss">
@use './property-baserecord.scss' as *;
</style>
